import { useQuery } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';

export default function useGetAllBuckets(id) {
  return useQuery(
    ['get-all-buckets', id],
    async () => {
      const res = await makeApiRequest.get(
        createQueryParamsForGetReq(apiEndPoints.BUCKETS_API, {
          task_board_id: id,
        })
      );
      return res.data;
    },
    {
      enabled: id ? true : false,
    }
  );
}
